import { NUMBER_PATTERN, TransportMode } from '../../../../../common/constants';
import { ControlProperty, DatepickerRangeModel, DatepickerRangeOutput } from '../../../../../common/models';
import { assignObjectIfPropertyValueValid } from '../../../../../common/utils';
import { DeviationType } from '../../../../models';
import { DraggableFilterType, MonitoringStatus } from '../../../../constants';
import { ArrivalsDepartureGroupsName, TransportFilterName } from '../constants';
import { DeliveryService, Origin, Region, ServiceLevel } from '../constants/transport-list.constant';
import { FreightMode } from '../../../shipment-transport-order/constants';
import { ListViewMode } from '../../constants';
import { Validators } from '@angular/forms';

export const TRANSPORT_FILTER_TYPE_BY_NAME: Map<TransportFilterName, DraggableFilterType> = new Map([
  [TransportFilterName.TransportOrderNumbers, DraggableFilterType.ChipsInput],
  [TransportFilterName.LoadNumbers, DraggableFilterType.ChipsInput],
  [TransportFilterName.MaterialNumbers, DraggableFilterType.ChipsInput],
  [TransportFilterName.DeliveryNoteNumbers, DraggableFilterType.ChipsInput],
  [TransportFilterName.HouseAirwayBills, DraggableFilterType.ChipsInput],
  [TransportFilterName.IStarNumbers, DraggableFilterType.ChipsInput],
  [TransportFilterName.TruckPlates, DraggableFilterType.ChipsInput],
  [TransportFilterName.TrailerPlates, DraggableFilterType.ChipsInput],
  [TransportFilterName.FlightNumbers, DraggableFilterType.ChipsInput],
  [TransportFilterName.VesselNames, DraggableFilterType.ChipsInput],
  [TransportFilterName.TransportModes, DraggableFilterType.MultipleSelect],
  [TransportFilterName.Origins, DraggableFilterType.MultipleSelect],
  [TransportFilterName.Regions, DraggableFilterType.MultipleSelect],
  [TransportFilterName.Statuses, DraggableFilterType.MultipleSelect],
  [TransportFilterName.FreightModes, DraggableFilterType.MultipleSelect],
  [TransportFilterName.ServiceLevels, DraggableFilterType.MultipleSelect],
  [TransportFilterName.DeliveryServices, DraggableFilterType.MultipleSelect],
  [TransportFilterName.DeviationTypes, DraggableFilterType.MultipleSelect],
  [TransportFilterName.DeviationHours, DraggableFilterType.Input],
  [TransportFilterName.Carriers, DraggableFilterType.ChipsInput],
  [TransportFilterName.Pickups, DraggableFilterType.ChipsInput],
  [TransportFilterName.ShipTos, DraggableFilterType.ChipsInput],
  [TransportFilterName.Consignors, DraggableFilterType.ChipsInput],
  [TransportFilterName.Consignees, DraggableFilterType.ChipsInput],
  [TransportFilterName.ReasonCodes, DraggableFilterType.ChipsInputPopup],
  [TransportFilterName.StatusCodes, DraggableFilterType.ChipsInputPopup],
  [TransportFilterName.EstimatedDepartureTime, DraggableFilterType.RangeDatepicker],
  [TransportFilterName.EstimatedArrivalTime, DraggableFilterType.RangeDatepicker],
  [TransportFilterName.ActualDepartureTime, DraggableFilterType.RangeDatepicker],
  [TransportFilterName.ActualArrivalTime, DraggableFilterType.RangeDatepicker],
  [TransportFilterName.PlannedDepartureTime, DraggableFilterType.RangeDatepicker],
  [TransportFilterName.PlannedArrivalTime, DraggableFilterType.RangeDatepicker],
]);

export const TRANSPORT_FILTER_SELECT_OPTIONS_BY_NAME = new Map<TransportFilterName, string[]>([
  [TransportFilterName.Regions, Object.values(Region)],
  [TransportFilterName.FreightModes, Object.values(FreightMode)],
  [TransportFilterName.TransportModes, Object.values(TransportMode)],
  [TransportFilterName.Statuses, Object.values(MonitoringStatus)],
  [TransportFilterName.ServiceLevels, Object.values(ServiceLevel)],
  [TransportFilterName.DeliveryServices, Object.values(DeliveryService)],
  [TransportFilterName.Origins, Object.values(Origin)],
  [TransportFilterName.DeviationTypes, Object.values(DeviationType)],
]);

export type ArrivalsDepartureGroupTimestampValues = {
  [key in ArrivalsDepartureGroupsName]: DatepickerRangeModel;
};
export type ArrivalsDepartureGroupDateValues = {
  [key in ArrivalsDepartureGroupsName]: DatepickerRangeOutput;
};

export class TransportListFiltersModelBase {
  viewMode?: ListViewMode = ListViewMode.Load;
  [TransportFilterName.TransportModes]: TransportMode[] = [];
  [TransportFilterName.Regions]: Region[] = [];
  [TransportFilterName.FreightModes]: FreightMode[] = [];
  [TransportFilterName.Statuses]: MonitoringStatus[] = [];
  [TransportFilterName.ServiceLevels]: ServiceLevel[] = [];
  [TransportFilterName.Origins]: Origin[] = [];
  [TransportFilterName.Carriers]: string[] = [];
  [TransportFilterName.Pickups]: string[] = [];
  [TransportFilterName.ShipTos]: string[] = [];
  [TransportFilterName.DeliveryServices]: DeliveryService[] = [];
  [TransportFilterName.TransportOrderNumbers]: string[] = [];
  [TransportFilterName.LoadNumbers]: string[] = [];
  [TransportFilterName.MaterialNumbers]: string[] = [];
  [TransportFilterName.IStarNumbers]: string[] = [];
  [TransportFilterName.Consignors]: string[] = [];
  [TransportFilterName.Consignees]: string[] = [];
  [TransportFilterName.HouseAirwayBills]: string[] = [];
  [TransportFilterName.DeliveryNoteNumbers]: string[] = [];
  [TransportFilterName.ReasonCodes]: string[] = [];
  [TransportFilterName.StatusCodes]: string[] = [];
  [TransportFilterName.TruckPlates]: string[] = [];
  [TransportFilterName.TrailerPlates]: string[] = [];
  [TransportFilterName.FlightNumbers]: string[] = [];
  [TransportFilterName.VesselNames]: string[] = [];
  [TransportFilterName.DeviationTypes]: DeviationType[] = [];
  [TransportFilterName.DeviationHours]: number = null;
  profileId: number = null;
  profileName = '';

  constructor(params?: TransportListFiltersModelBase) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class TransportListFiltersDatepickerRangeModel extends TransportListFiltersModelBase {
  [TransportFilterName.EstimatedDepartureTime] = new DatepickerRangeModel();
  [TransportFilterName.EstimatedArrivalTime] = new DatepickerRangeModel();
  [TransportFilterName.ActualDepartureTime] = new DatepickerRangeModel();
  [TransportFilterName.ActualArrivalTime] = new DatepickerRangeModel();
  [TransportFilterName.PlannedDepartureTime] = new DatepickerRangeModel();
  [TransportFilterName.PlannedArrivalTime] = new DatepickerRangeModel();

  constructor(params?: TransportListFiltersDatepickerRangeModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class TransportListFiltersDatepickerRangeOutput extends TransportListFiltersModelBase {
  [TransportFilterName.EstimatedDepartureTime] = new DatepickerRangeOutput();
  [TransportFilterName.EstimatedArrivalTime] = new DatepickerRangeOutput();
  [TransportFilterName.ActualDepartureTime] = new DatepickerRangeOutput();
  [TransportFilterName.ActualArrivalTime] = new DatepickerRangeOutput();
  [TransportFilterName.PlannedDepartureTime] = new DatepickerRangeOutput();
  [TransportFilterName.PlannedArrivalTime] = new DatepickerRangeOutput();

  constructor(params?: TransportListFiltersDatepickerRangeOutput) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class TransportPlannerProfileFilterModel extends TransportListFiltersDatepickerRangeModel {
  constructor(params?: TransportPlannerProfileFilterModel) {
    super();

    if (this.viewMode) {
      delete this.viewMode;
    }

    if (params) {
      assignObjectIfPropertyValueValid(this, params);
    }
  }
}

export class TransportListFiltersForm {
  constructor(
    model: TransportListFiltersDatepickerRangeModel,
    public viewMode: ControlProperty<ListViewMode> = [model.viewMode, []],
    public transportModes: ControlProperty<TransportMode[]> = [model.transportModes, []],
    public deviationTypes: ControlProperty<DeviationType[]> = [model.deviationTypes, []],
    public deviationHours: ControlProperty<number> = [model.deviationHours, [Validators.pattern(NUMBER_PATTERN)]],
    public regions: ControlProperty<Region[]> = [model.regions, []],
    public freightModes: ControlProperty<FreightMode[]> = [model.freightModes, []],
    public statuses: ControlProperty<string[]> = [model.statuses, []],
    public serviceLevels: ControlProperty<ServiceLevel[]> = [model.serviceLevels, []],
    public origins: ControlProperty<Origin[]> = [model.origins, []],
    public deliveryServices: ControlProperty<DeliveryService[]> = [model.deliveryServices, []],
    public transportOrderNumbers: ControlProperty<string[]> = [model.transportOrderNumbers, []],
    public loadNumbers: ControlProperty<string[]> = [model.loadNumbers, []],
    public materialNumbers: ControlProperty<string[]> = [model.materialNumbers, []],
    public iStarNumbers: ControlProperty<string[]> = [model[TransportFilterName.IStarNumbers], []],
    public carriers: ControlProperty<string[]> = [model.carriers, []],
    public shipTos: ControlProperty<string[]> = [model.shipTos, []],
    public pickups: ControlProperty<string[]> = [model.pickups, []],
    public consignors: ControlProperty<string[]> = [model.consignors, []],
    public consignees: ControlProperty<string[]> = [model.consignees, []],
    public houseAirwayBills: ControlProperty<string[]> = [model.houseAirwayBills, []],
    public reasonCodes: ControlProperty<string[]> = [model.reasonCodes, []],
    public statusCodes: ControlProperty<string[]> = [model.statusCodes, []],
    public deliveryNoteNumbers: ControlProperty<string[]> = [model.deliveryNoteNumbers, []],
    public truckPlates: ControlProperty<string[]> = [model.truckPlates, []],
    public trailerPlates: ControlProperty<string[]> = [model.trailerPlates, []],
    public flightNumbers: ControlProperty<string[]> = [model.flightNumbers, []],
    public vesselNames: ControlProperty<string[]> = [model.vesselNames, []],
    public estimatedDepartureTime: ControlProperty<DatepickerRangeModel> = [model.estimatedDepartureTime, []],
    public estimatedArrivalTime: ControlProperty<DatepickerRangeModel> = [model.estimatedArrivalTime, []],
    public actualDepartureTime: ControlProperty<DatepickerRangeModel> = [model.actualDepartureTime, []],
    public actualArrivalTime: ControlProperty<DatepickerRangeModel> = [model.actualArrivalTime, []],
    public plannedDepartureTime: ControlProperty<DatepickerRangeModel> = [model.plannedDepartureTime, []],
    public plannedArrivalTime: ControlProperty<DatepickerRangeModel> = [model.plannedArrivalTime, []],
    public profileId: ControlProperty<number> = [model.profileId, []],
    public profileName: ControlProperty<string> = [model.profileName, []],
  ) {}
}
